import React, { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const FemaleStethoscope: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    preserveAspectRatio="xMinYMin meet"
    viewBox="320 20 200 450"
    {...props}
  >
    <style>
      {
        '.st7{fill:#ebe6e1}.st8{fill:#d2c8be}.st9{fill:#eb4600}.st11{fill:#000c44}.st12{fill:#b86121}.st13{fill:#933c21}'
      }
    </style>
    <path
      id="background"
      d="M0 0h576v576H0z"
      style={{
        fill: '#d9f6fa',
      }}
    />
    <g id="ILLUSTRATION">
      <defs>
        <path id="SVGID_1_" d="M0 0h576v576H0z" />
      </defs>
      <clipPath id="SVGID_00000003793532251974749490000015065401150682171033_">
        <use
          xlinkHref="#SVGID_1_"
          style={{
            overflow: 'visible',
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
        }}
      >
        <path
          id="XMLID_00000137819235475972096950000015444073139506305444_"
          d="M155.88 363.45c-1.62-.12-3.31-.19-4.83.39-1.79.68-3.15 2.16-4.28 3.7-6.6 8.97-7.59 20.76-8.22 31.88-2.74 47.96-1.65 65.96 9.51 120.57C154.49 551.48 170.09 681 174.54 681c17.97 0 196.72-1.83 213.65-1.83 4.28-98.29 38.29-198.74 33.49-297.03-.2-4.15-2.68-8.43-4.42-12.2-9.59-20.8-247.23-5.4-261.38-6.49z"
          style={{
            fill: '#002677',
          }}
        />
        <defs>
          <path
            id="SVGID_00000092447878375651335890000001401427871023461296_"
            d="M155.88 363.45c-1.62-.12-3.31-.19-4.83.39-1.79.68-3.15 2.16-4.28 3.7-6.6 8.97-7.59 20.76-8.22 31.88-2.74 47.96-1.65 65.96 9.51 120.57C154.49 551.48 170.09 681 174.54 681c17.97 0 196.72-1.83 213.65-1.83 4.28-98.29 38.29-198.74 33.49-297.03-.2-4.15-2.68-8.43-4.42-12.2-9.59-20.8-247.23-5.4-261.38-6.49z"
          />
        </defs>
        <clipPath id="SVGID_00000148657041157007332050000012577669427632241839_">
          <use
            xlinkHref="#SVGID_00000092447878375651335890000001401427871023461296_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <path
          d="M344.66 462.47v231.96c25.04 0 26.96.83 51.41-4.58 1.52-.34 3.14-.76 4.16-1.93 1.03-1.18 1.22-2.85 1.36-4.41 2.42-26.2 4.85-52.4 7.26-78.6-.24 2.45 50.51-247.18 23.46-244.73 4.38-.4-70.75 8.57-89.15 21.44-10.93 7.64-6.19 22.52-5.11 34.38 1.39 15.13 6.61 31.45 6.61 46.47z"
          style={{
            clipPath:
              'url(#SVGID_00000148657041157007332050000012577669427632241839_)',
            fill: '#000c44',
          }}
        />
      </g>
      <g
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
        }}
      >
        <path
          id="XMLID_00000071555549356939063950000003817917464689095849_"
          d="M389.7 38.34c-15.41-10.78-32.58-18.61-49.62-25.97-5.87-2.54-12.1-5.12-18.41-4.68-4.74-9.98-7.31-22.72-5.41-44.95h-84.73c2 23.35-.94 36.22-6.14 46.44-.27-.12-.56-.23-.88-.32-2.69-.76-5.55.1-8.2 1.02-26.57 9.26-50.43 25.85-69.53 46.42-23.61 25.41-39.21 56.87-50.52 89.4-12.48 35.87-21.41 73.63-28.56 110.91.89-4.62 24.4-2.53 37.18.45 30.6 5.7 47.03 17.29 47.03 17.29-2.55 17.68-2.79 35.22-5.19 51.76-2.84 19.61-9.82 39.45-10.81 59.3-.48 9.62-.86 19.75 3.46 28.36 5.83 11.62 18.67 17.65 30.58 22.84 30.76 13.4 55.08 21.1 89.47 33.58 6.83-12.38 13.09-20.63 21.91-35.1 7.77 10.18 14 20.7 25.49 35.8 16.7-8.43 41.67-20.18 58.69-27.94 34.63-15.8 53.82-31.1 55.66-35.36 2.57-5.96 2.9-12.88 2.59-19.26-.52-10.62-2.87-20.86-4.78-31.26-1.99-10.85-3.8-21.76-4.39-32.78-.3-5.53-.52-11.56 1.25-16.89 3.99-12.01 16.27-21.83 25.92-29.18 15.55-11.85 33.16-21.78 51.1-29.56l18.1-14.94C468.28 179.17 451.04 81.26 389.7 38.34z"
          style={{
            fill: '#0072a6',
          }}
        />
        <defs>
          <path
            id="SVGID_00000037691337662793861680000001544434779463690412_"
            d="M389.7 38.34c-15.41-10.78-32.58-18.61-49.62-25.97-5.87-2.54-12.1-5.12-18.41-4.68-4.74-9.98-7.31-22.72-5.41-44.95h-84.73c2 23.35-.94 36.22-6.14 46.44-.27-.12-.56-.23-.88-.32-2.69-.76-5.55.1-8.2 1.02-26.57 9.26-50.43 25.85-69.53 46.42-23.61 25.41-39.21 56.87-50.52 89.4-12.48 35.87-21.41 73.63-28.56 110.91.89-4.62 24.4-2.53 37.18.45 30.6 5.7 47.03 17.29 47.03 17.29-2.55 17.68-2.79 35.22-5.19 51.76-2.84 19.61-9.82 39.45-10.81 59.3-.48 9.62-.86 19.75 3.46 28.36 5.83 11.62 18.67 17.65 30.58 22.84 30.76 13.4 55.08 21.1 89.47 33.58 6.83-12.38 13.09-20.63 21.91-35.1 7.77 10.18 14 20.7 25.49 35.8 16.7-8.43 41.67-20.18 58.69-27.94 34.63-15.8 53.82-31.1 55.66-35.36 2.57-5.96 2.9-12.88 2.59-19.26-.52-10.62-2.87-20.86-4.78-31.26-1.99-10.85-3.8-21.76-4.39-32.78-.3-5.53-.52-11.56 1.25-16.89 3.99-12.01 16.27-21.83 25.92-29.18 15.55-11.85 33.16-21.78 51.1-29.56l18.1-14.94C468.28 179.17 451.04 81.26 389.7 38.34z"
          />
        </defs>
        <clipPath id="SVGID_00000018208454718400372130000005405767311050970290_">
          <use
            xlinkHref="#SVGID_00000037691337662793861680000001544434779463690412_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <path
          d="M390.34 338.63c-4.31-1.09-14.33.46-18.72-.23-18.83-2.95-38.02-2.12-57.05-1.29-19.76.87-39.52 1.73-59.26 2.93-35.92 2.18-71.78 5.46-107.5 9.83-.93 5.6 6.23 8.7 11.84 9.59 63.36 10.05 128.76.99 191.79 12.9 3.61.68 7.31 1.47 10.39 3.48 20.23 13.18-10.14 67.42-19.14 81.36-2.55 3.95-6.33 10.16-11.57 10.75 6.74-.78 96.15-46.84 97.11-55.71 1.22-11.33 8.05-37.45.18-48.22-5.29-7.24-5.87-15.83-14.09-19.41-7.14-3.11-16.43-4.07-23.98-5.98z"
          style={{
            clipPath:
              'url(#SVGID_00000018208454718400372130000005405767311050970290_)',
            fill: '#00448a',
          }}
        />
      </g>
      <path
        d="M208.97 13.23c.13-1.21.34-2.42.61-3.6.18-.8.37-1.59.63-2.37.12-.36.29-.71.36-1.08.07-.38.1-.71.3-1.06.05-.09.11-.18.19-.24s.17-.09.26-.12c4.26-1.35 9.11-1.79 13.57-1.62-.24-.01-1.53 1.8-1.78 2.06-.56.57-1.05.91-1.75 1.26-1.75.88-3.3 2.3-4.96 3.36-2.23 1.42-4.76 3.12-7.43 3.41z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#00448a',
        }}
      />
      <g
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
        }}
      >
        <ellipse
          cx={371.35}
          cy={139.66}
          className="st7"
          rx={19.25}
          ry={18.19}
          transform="rotate(-86.354 371.351 139.65)"
        />
        <path
          d="M378.02 95.59c-.67-.04-1.31.2-1.81.67-.5.47-.8 1.13-.84 1.84-.63 10.99-4.86 31.89-4.9 32.1-.14.69-.02 1.4.34 1.99.36.59.92 1 1.58 1.14.21.05.43.06.64.05.04 0 .08-.01.12-.01 1.08-.11 1.99-.96 2.22-2.1.18-.87 4.34-21.44 5-32.9.08-1.45-.98-2.71-2.35-2.78z"
          className="st8"
        />
        <ellipse
          cx={371.35}
          cy={139.66}
          className="st8"
          rx={11.13}
          ry={10.51}
          transform="rotate(-86.354 371.351 139.65)"
        />
        <path
          d="M375.17 44.94c-8.83-19.89-24.02-33.29-45.13-39.83l-.11-.04c-.48-.15-.86-.27-1.14-.36-.73-.26-1.51-.31-2.25-.07-1.13.37-2 1.25-2.38 2.4-.32.96-.27 1.98.15 2.89.41.91 1.14 1.59 2.04 1.92.38.14.93.31 1.64.53 19.08 5.91 32.78 17.97 40.71 35.83 6.45 14.53 8.13 32.84 5.11 55.96-.08.59.31 1.13.86 1.21l5.06.73c.56.08 1.09-.34 1.16-.94 3.22-24.62 1.35-44.33-5.72-60.23z"
          className="st9"
        />
      </g>
      <path
        d="M67.7 256.61c.98-5.14 29.98-1.97 41.04 1.48 11.05 3.45 40.48 25.75 23.41 25.75s-67.02-13.77-64.45-27.23z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#00448a',
        }}
      />
      <path
        d="M148.08 318.24c-4.23 16.84-15.51 27.73-48.66 23.65-32.35-3.98-21.13-87.83-21.11-87.98 8.13-.01 19.16 1.42 26.57 3.15 30.6 5.7 47.04 17.29 47.04 17.29-1.46 15.45-.69 31.32-3.84 43.89zM316.26-37.25h-84.73c1.29 15.12 1.78 29.75-9.22 41.19-3.17 3.29-8.44 5.99-10.56 10.13-3.07 5.99 1.27 10.27 4.6 15.52 14.29 22.53 32.64 41.4 45.34 65.04 4.05 7.53 7.55 15.33 11 23.15 2.68 6.08 3.77 8.81 10.26 5.75 19.1-8.99 29.84-40.35 37.36-58.18 6.62-15.69 12.62-31.74 17.68-48-12.83-19.87-25.34-12.41-21.73-54.6z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#b86121',
        }}
      />
      <g
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
        }}
      >
        <ellipse
          cx={143.33}
          cy={102.75}
          className="st8"
          rx={2.37}
          ry={0.98}
          transform="rotate(-4.399 143.321 102.748)"
        />
        <path
          d="M179.02 234.92c-8.79-.56-16.63-4.34-22.48-10.35-7.63 6.05-17.53 8.77-27.9 6.85l-5.79-1.07.84-4.87 5.79 1.07c9.01 1.67 17.47-.51 24.01-5.56-4.22-5.66-6.92-12.75-7.5-20.7l-6.17-97.73c-.08-1.3-.08-2.43 0-3.66.93-14.41 12.76-25.43 26.37-24.56s23.94 13.31 23.02 27.73c-.08 1.19-.24 2.28-.46 3.55l-18.62 96.19c-1.6 7.82-5.19 14.51-10.1 19.6 5.84 5.85 13.95 9.09 23.11 8.59l5.88-.32.21 4.94-5.88.32c-1.47.07-2.91.07-4.33-.02zM165.87 79.28c-11.05-.71-20.64 8.23-21.39 19.92-.07 1.01-.06 1.91 0 3l6.17 97.7c.51 6.93 2.77 13.05 6.33 17.94 4.15-4.39 7.18-10.18 8.58-17.01l18.6-96.12c.19-1.08.32-1.97.38-2.94.75-11.7-7.63-21.79-18.67-22.49z"
          className="st8"
        />
        <path
          d="M175.71 75.39c-3.28-1.62-5.14-5.33-4.42-9.1 2.17-11.49 5.9-20.48 11.45-27.81 3.29-4.34 7.47-7.96 11.94-11.03a81.26 81.26 0 0 1 7.2-4.38c2.07-1.12 4.05-1.87 4.75-4.39.43-1.53.14-3.26-.82-4.53-.31-.41-.7-.78-1.15-1.02-2.49-1.31-5.32 1.24-7.34 2.5-2.59 1.62-5.1 3.38-7.52 5.25-4.76 3.69-9.23 7.86-12.88 12.67-6.4 8.45-10.64 18.67-13.04 31.63-.79 4.24-3.71 7.7-7.58 9.09-9.78 3.51-17.14 12.99-17.88 24.53-.08 1.3-.08 2.49 0 3.86l1.55 24.58c.05.85.75 1.5 1.56 1.43l4.54-.36c.81-.06 1.42-.81 1.36-1.66l-1.55-24.58c-.06-.98-.07-1.8-.01-2.71.54-8.98 6.62-16.57 14.98-18.27 12.59-2.56 23.1 8.01 22.3 20.57-.06.9-.18 1.74-.36 2.74l-4.69 24.21c-.16.84.35 1.66 1.14 1.82l4.45.93c.79.17 1.57-.38 1.73-1.22l4.7-24.29c.23-1.31.4-2.45.48-3.71.75-11.65-5.47-22.09-14.89-26.75z"
          className="st9"
        />
        <path
          d="m199.9 232.34-.07-1.56c-.1-2.39-1.91-4.37-4.17-4.4-.11 0-.22 0-.33.01-.93.05-1.8.37-2.53.87-1.48 1.02-3.23 1.53-4.99 1.63l-.66.04c-.82.05-1.56.41-2.13.97l.13 4.94c.59.52 1.35.82 2.18.77l.99-.06c1.75-.1 3.46.35 5.04 1.15.63.32 1.33.51 2.07.52.22 0 .43-.01.65-.03 2.27-.25 3.92-2.43 3.82-4.85zM108.8 224.71l-.24 1.55c-.37 2.37 1.01 4.7 3.22 5.22.11.02.21.05.32.06a4.9 4.9 0 0 0 2.64-.3c1.65-.68 3.45-.8 5.2-.51l.65.11c.81.13 1.61-.06 2.27-.49l.84-4.87c-.47-.64-1.16-1.1-1.98-1.23l-.98-.16c-1.73-.29-3.32-1.09-4.7-2.22a4.83 4.83 0 0 0-2.56-1.07c-2.27-.26-4.31 1.52-4.68 3.91z"
          className="st11"
        />
      </g>
      <g
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
        }}
      >
        <path
          d="M428.23 282.68c-8.01-11.38-11.81-19.26-11.81-19.26-1.73-.25-4.21-4.53-5.31-1.78-1.1 2.75-12.98 1.07-12.98 1.07-4.82-9-31.72 2.67-31.72 2.67l-6.09 6.27c-16.07-4.18-27.51 7.22-28.9 11.6-1.32 4.13 1.8 6.93 9.68 7.58 8.74.73 24.57 2.73 37.9 11.78l-.01-.02c20.42 15.4 40.2 19.14 47.58 13.46.55-.42 1.11-1 1.67-1.68l-.01-31.69z"
          className="st12"
        />
        <path
          d="M488.03 228.64s14.87 47.6 5.17 77.86c-10.51 32.8-49.75 28.74-80.84 13.42 0 0 6.2-50.01 7.88-50.8 1.67-.78 28.68-42.24 67.79-40.48zM368.26 257c-3.38-1.63-15.49-.31-19.14.41-7.85 1.55-20.79 4.35-20.79 4.35-9.13 1.69-6.77 6.73-4.91 8.03 4.9 3.41 14.77 3.25 24.24 2.46 4.75-.39 7.39 1.03 7.39 1.03 7.46-1.9 16.78-7.78 16.78-7.78l-3.57-8.5z"
          className="st12"
        />
        <path
          d="M362.88 253.36c-3.71.17-7.28 1.53-10.24 3.92-6.34 5.14-16.69 13.83-16.69 13.83-2.85 2.28-6.27 4.28-3.37 8.14 3.95 3.81 20-5.14 30.34-11.8 4.07-2.62 17.2-14.09 17.2-14.09h-17.24z"
          className="st13"
        />
        <path
          d="M387.91 249.78c-2.88-.01-4.86 1.31-6.85 2.7-6.67 4.65-19.06 12.66-19.06 12.66-3 2.06-6.06 2.96-4.85 6.68 1.58 4.26 13.98 3.25 23.97-4 9.07-6.58 12.42-4.57 12.42-4.57l7.74-10.5c0 .01-10.8-2.96-13.37-2.97z"
          className="st13"
        />
        <path
          d="M415.91 274.12c1.21 6.7.13 22.66 5.26 31.62l15.28 1.76c-.17-10.11-3.24-17.67-6.57-22.52-8.82-12.85-13.33-28.76-22.59-33.8v.01c-1.27-.7-2.89-1.2-4.99-1.32-2.68-.18-5.25.15-6.48 2.11-3.3 5.26-8.53 14.81-10.45 18.36-.45.82-.92 1.63-1.4 2.43-1.49 2.5-2.48 5.29-.27 7.19 2.68 2.02 8.23-.68 13.39-6.76 4.78-5.63 8.83-9.66 9.4-9.71 3.71-.34 7.78 1.53 9.42 10.63z"
          className="st13"
        />
      </g>
      <g
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
        }}
      >
        <path
          d="M450.47 312.41c-.77-1.13-2.02-1.91-3.57-1.91H99.47c-1.54 0-2.79.78-3.56 1.9-.9 1.31-.69 3.13.34 4.32l28.74 33.07h294.34c1.23 0 2.4-.54 3.23-1.5l27.58-31.58c1.02-1.18 1.22-3 .33-4.3z"
          className="st8"
        />
        <path
          d="M448.05 301.2H98.32c-3.77 0-6.83 3.24-6.83 7.23 0 1.8.62 3.44 1.65 4.7.06.08 1.24 1.44 3.11 3.59-1.03-1.19-1.24-3.02-.34-4.33.77-1.12 2.02-1.9 3.56-1.9H446.9c1.55 0 2.79.78 3.57 1.91.9 1.31.69 3.13-.34 4.32 1.83-2.12 2.98-3.44 3.02-3.49a7.418 7.418 0 0 0 1.73-4.8c0-3.99-3.06-7.23-6.83-7.23z"
          className="st7"
        />
        <path
          d="M395.63 308.96h17.42c1.47 0 2.67-1.2 2.67-2.67v-1.08c0-1.47-1.2-2.67-2.67-2.67h-17.42c-1.47 0-2.67 1.2-2.67 2.67v1.08c0 1.48 1.2 2.67 2.67 2.67z"
          className="st8"
        />
      </g>
      <path
        d="M170.55 327.34c-.33-2.24-2.45-4.03-5.64-4.75-.01-.13-.01-.27-.02-.4-.29-3.14-4.08-5.64-9.59-5.64-6.35-.18-23.03 1.42-23.03 1.42s-42.23 3.14-53.34-7.99c0 0-4.13 4.77-5.77 9.01-2.69 6.93-.4 8.97 1.16 12.37.37.81.29 1.79.18 2.66-.15 1.17-.43 2.33-.64 3.49-.45 2.58-.56 5.34.95 7.57.76 1.12 1.82 2.03 2.99 2.65 1.41.74 2.43.71 3.36 1.52 2.3 2 1.1 5.44 4.15 7.94 1.18.91 2.81 1.35 3.51 1.5 2.21.38 4.92.29 7 .1.2.2 0 0 0 0 6.32 6.41 15.8 3.72 22.71.1 7.73-4.05 14.77-9.46 21.93-14.51 2.91-2.05 5.85-4.16 8.92-5.98 4-1.35 8.98-3.34 13.42-4.67 6.31-1.99 8.26-2.93 7.75-6.39z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#933c21',
        }}
      />
      <path
        d="M74.69 342.63c.93.99 2.11 1.65 3.42 1.84 2.93.42 8.03-.11 13.27-1.83 2.1-.74 3.79-1.51 5.03-2.14l.05-.02c.88-.45.76-1.82-.19-2.08l-21.61-5.74c-.32 2.41-1.52 5.21-.94 8.13.14.69.48 1.33.95 1.83.01 0 .01.01.02.01zM90.04 310.17s2.22 3.52 15.93 4.09c12.89.53 19.46-.84 28.08-1.9 5.03-.62 15.88-.33 13.3 6.97-1.33 3.76-20.27 5.6-34.48 8.85-9.26 2.12-14.16-1.25-34.72-4.9-4.6-.82-5.6-3.24-6.09-5.47-.32-1.45-.65-6.04 2.75-8.84 1.44-1.18 3.86-3.11 6.68-2.09l8.55 3.29z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#b86121',
        }}
      />
      <path
        d="M211.68 4.51c.54-.15.89-.15 1.67-.3-.48.88-.41 2.17-.34 3.14.08 1.1.32 2.18.64 3.24.66 2.12 1.67 4.12 2.65 6.1 3.18 6.43 8.73 12.14 13.24 17.74 9.51 11.8 19.93 22.84 29.5 34.58 4.08 5 26.1 50.44 23.77 57.23-1.92.98-4.35.32-6.02-1.04s-2.76-3.29-3.8-5.18c-6.81-12.34-14.4-24.24-21.24-36.56-1.25-2.5-2.13-4.48-3.9-6.72-1.47-1.87-3.49-5.18-5.73-6.16-2.33-1.02-6.81 0-8.85 1.3-2.42 1.54-3.8 4.32-6.15 5.97-.81.57-1.85 1.01-2.78.68-.42-.14-.77-.43-1.1-.71-5.54-4.7-8.28-11.62-11.8-17.9-3.75-6.69-7.46-13.43-10.36-20.55-2.06-5.07-8.21-17.06-6.89-22.62.57-2.4 4.01-4.51 5.82-5.92 2.94-2.28 6.23-3.88 9.58-5.5.68-.33 1.38-.62 2.09-.82z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#0072a6',
        }}
      />
      <path
        d="M233.99 81.58c1.99-.14 3.89.3 5.82 2.11 1.47 1.37 2.05 3.28 3.06 4.96 1.06 1.76 2.27 3.54 3.6 5.11 2.79 3.28 6.24 5.91 9.65 8.51l6.37 4.84c3.02 2.3 6.17 4.65 9.87 5.51-.73-4.41-4.22-7.79-6.97-11.08-3.18-3.79-6.17-7.74-8.86-11.9-4.18-6.44-6.91-17.35-13.79-21.46-6-3.59-9.2 2.23-13.08 7.19-2.43 3.1-5.62 5.98-8.7 8.51 1.23-.04 2.32-.25 3.56-.29 3.56-.37 6.6-1.81 9.47-2.01z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#00448a',
        }}
      />
      <path
        d="M330.36 1.44c-2.1-.99-5.75-2.08-8.34-1.67 7.05 12.51 8.33 27.23 2.5 40.08-5.57 12.28-11.28 24.51-17.11 36.67-5.13 10.7-22.74 37.21-24.43 40.13s-2.62 6.47-1.64 9.7c.08.27.19.56.43.73.32.23.76.14 1.14.03 6.49-1.86 11.11-7.5 14.89-13.1 8.04-11.89 17.27-22.97 25.74-34.57 13.12-17.95 26.35-40.01 19.2-62.93-1.87-5.98-6.32-12.22-12.38-15.07z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#0072a6',
        }}
      />
      <path
        d="M324.88 72.13c3.76-6.4 10.01-18.84 15.97-4.08.49 1.21.81 2.49 1.08 3.77.88 4.12 2.38 8.11 4.43 11.79-3.27.52-6.68.89-9.87-.03s-6.13-3.4-6.65-6.68c-2.14 2.23-8.44 7.41-12.72 10.92-.68.55-1.6-.27-1.14-1.01 2.95-4.65 7.09-11.6 8.9-14.68z"
        style={{
          clipPath:
            'url(#SVGID_00000003793532251974749490000015065401150682171033_)',
          fill: '#00448a',
        }}
      />
    </g>
  </Box>
)
export default FemaleStethoscope
